/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class TimeOfYear {
  'month': number;
  'dayOfMonth': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "month",
      "baseName": "month",
      "type": "number",
      "format": ""
    },
    {
      "name": "dayOfMonth",
      "baseName": "dayOfMonth",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return TimeOfYear.attributeTypeMap;
  }

  public constructor() {
  }
}

